export default {
      id: "comments-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#comments",
      toString: function () {
        return this.url;
      }
    }